import { LocalStorageKey } from '@/shared/config';
import type { FullHeadMPRPaneLayout } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { safeLocalStorage } from '@/shared/lib';

import {
  DEFAULT_FULL_HEAD_MPR_PANE_LAYOUT,
  FULL_HEAD_MPR_PANE_LAYOUTS,
} from '../config';

// NOTE: localStorage is a temporary home for the pane layout preference;
// it should move to server-side user settings once they exist.
export const parseFullHeadMprPaneLayout = (
  value: string | null,
  fallback: FullHeadMPRPaneLayout = DEFAULT_FULL_HEAD_MPR_PANE_LAYOUT,
): FullHeadMPRPaneLayout =>
  FULL_HEAD_MPR_PANE_LAYOUTS.includes(value as FullHeadMPRPaneLayout)
    ? (value as FullHeadMPRPaneLayout)
    : fallback;

export const readFullHeadMprPaneLayout = (): FullHeadMPRPaneLayout =>
  parseFullHeadMprPaneLayout(
    safeLocalStorage.getItem(LocalStorageKey.fhmprPaneLayout),
  );

export const writeFullHeadMprPaneLayout = (
  layout: FullHeadMPRPaneLayout,
): void => {
  safeLocalStorage.setItem(LocalStorageKey.fhmprPaneLayout, layout);
};
